import { IError, BaseError } from '.'

export const ERROR_API_NAME = 'APIError'

export class APIError extends BaseError implements IError {
  constructor(code: number, description: string = '') {
    super(ERROR_API_NAME, code, description)
  }
}
